exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3BiuU60R78OeRV1re2JK2z {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n._3BiuU60R78OeRV1re2JK2z h2 {\n  margin-left: 10px;\n}\n\n._3TeX2Tg2zy9MDaylwW-mmX {\n  border-radius: 4px;\n  display: flex;\n  flex-flow: row wrap;\n  overflow: hidden;\n}\n\n._1BgioaTYB85wBNDlrPB6J_ {\n  background: #fff1;\n  border-bottom: 1px solid transparent;\n  color: #aaa;\n  cursor: pointer;\n  flex: 1;\n  padding: 5px 15px;\n  text-align: center;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n._1BgioaTYB85wBNDlrPB6J_._3g3f2u0J4LjWCkmCaTqp_6 {\n  background: #fff4;\n  color: #fff;\n}\n\n._1BgioaTYB85wBNDlrPB6J_:hover {\n  border-bottom-color: #ddd;\n}\n\n._1BgioaTYB85wBNDlrPB6J_:active {\n  background: #fff5;\n}\n\n._2oNoZNphb2s_6Gjtv9vMnY {\n  display: block;\n}\n\n._1sUxXOV6emeOnkvfD8jnYj {\n  display: block;\n  font-size: 0.8em;\n}\n", ""]);

// exports
exports.locals = {
	"RanksContainer": "_3BiuU60R78OeRV1re2JK2z",
	"Ranks": "_3TeX2Tg2zy9MDaylwW-mmX",
	"RankToggle": "_1BgioaTYB85wBNDlrPB6J_",
	"on": "_3g3f2u0J4LjWCkmCaTqp_6",
	"RankNumber": "_2oNoZNphb2s_6Gjtv9vMnY",
	"RankStatus": "_1sUxXOV6emeOnkvfD8jnYj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib??ref--1-1!./styles/Ranks.css
// module id = 214
// module chunks = 0